export default "__VITE_ASSET__0d172d35__"